



















































import { Component, Vue, Watch } from 'vue-property-decorator'
import { Route } from 'vue-router'
import { Form as ElForm, Input } from 'element-ui'
import { UserModule } from '@/store/modules/user'
import { isValidUsername } from '@/utils/validate'

@Component({
  name: 'Login',
})
export default class extends Vue {
  private validateUsername = (rule: any, value: string, callback: Function) => {
    if (!value) {
      callback(new Error('请输入用户名'))
    } else {
      callback()
    }
  }
  private validatePassword = (rule: any, value: string, callback: Function) => {
    if (value.length < 6) {
      callback(new Error('密码必须在6位以上'))
    } else {
      callback()
    }
  }
  private loginForm = {
    username: '',
    password: '',
  } as {
    username: String
    password: String
  }

  loginRules = {
    username: [{ validator: this.validateUsername, trigger: 'blur' }],
    password: [{ validator: this.validatePassword, trigger: 'blur' }],
  }
  private loading = false
  private redirect?: string

  @Watch('$route', { immediate: true })
  private onRouteChange(route: Route) {}

  // 登录
  private handleLogin() {
    console.log('开始登录，表单数据：', this.loginForm)
    ;(this.$refs.loginForm as ElForm).validate(async (valid: boolean) => {
      if (valid) {
        console.log('表单验证通过，准备发送登录请求')
        this.loading = true
        try {
          console.log('发送登录请求前...')
          const res = await UserModule.Login(this.loginForm as any)
          console.log('登录请求返回结果：', res)
          if (String(res.code) === '1') {
            console.log('登录成功，准备跳转首页')
            this.$router.push('/')
          } else {
            console.log('登录失败，错误信息：', res.msg)
            this.$message.error(res.msg || '登录失败')
            this.loading = false
          }
        } catch (error) {
          console.error('登录请求出错：', error)
          const errorMsg = error.response && error.response.data && error.response.data.msg ? error.response.data.msg : '用户名或密码错误！';
          console.log('显示错误信息：', errorMsg)
          this.$message.error(errorMsg)
          this.loading = false
        }
      } else {
        console.log('表单验证失败')
        return false
      }
    })
  }
}
